/**
 * Agentic Payment Ledger - Shared Constants
 *
 * Centralized configuration values used across ledger components.
 */

// API Endpoints (admin page_actions, proxied through Rails)
export const API_ENDPOINTS = {
    POOL_METRICS: "/admin/agentic_payment_ledger/pool_metrics",
    CREATED_TOKENS: "/admin/agentic_payment_ledger/created_tokens",
    RECONCILIATION: "/admin/agentic_payment_ledger/ledger_reconciliation",
    RUN_RECONCILIATION: "/admin/agentic_payment_ledger/run_ledger_reconciliation",
};

// Sort options
export const SORT_OPTIONS = [
    { value: "name", label: "Name (A-Z)" },
    { value: "balance", label: "Initial Supply" },
    { value: "supply", label: "Circulating Supply" },
    { value: "variation", label: "Variation %" },
];

// Filter options
export const FILTER_OPTIONS = [
    { value: "all", label: "All Currencies" },
    { value: "positive", label: "Positive Variation" },
    { value: "negative", label: "Negative Variation" },
];
